export default __webpack_public_path__ + "static/media/hht2_ep16_timeline_q03_b.cc2fdfe6.png";